import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  tripPlanViewOpened as tripPlanViewOpenedAction,
  stopDetailViewOpened as stopDetailViewOpenedAction,
  locationDetailViewOpened as locationDetailViewOpenedAction,
  tripRequestViewOpened as tripRequestViewOpenedAction,
  modeSelectorViewOpened as modeSelectorViewOpenedAction,
  transitTrackerViewOpened as transitTrackerViewOpenedAction,
  simpleStopViewOpened as simpleStopViewOpenedAction,
  vehicleDetailViewOpened as vehicleDetailViewOpenedAction,
  serviceAlertsViewOpened as serviceAlertsViewOpenedAction,
  routeListViewOpened as routeListViewOpenedAction,
  routeDetailViewOpened as routeDetailViewOpenedAction,
  payViewOpened as payViewOpenedAction,
  viewClosed as viewClosedAction,
} from '#/map/slice';

export default () => {
  const dispatch = useDispatch();

  const tripPlanViewOpened = useCallback(
    () => dispatch(tripPlanViewOpenedAction()),
    [dispatch]
  );
  const stopDetailViewOpened = useCallback(
    () => dispatch(stopDetailViewOpenedAction()),
    [dispatch]
  );
  const locationDetailViewOpened = useCallback(
    () => dispatch(locationDetailViewOpenedAction()),
    [dispatch]
  );
  const tripRequestViewOpened = useCallback(
    () => dispatch(tripRequestViewOpenedAction()),
    [dispatch]
  );
  const transitTrackerViewOpened = useCallback(
    () => dispatch(transitTrackerViewOpenedAction()),
    [dispatch]
  );
  const simpleStopViewOpened = useCallback(
    () => dispatch(simpleStopViewOpenedAction()),
    [dispatch]
  );
  const serviceAlertsViewOpened = useCallback(
    () => dispatch(serviceAlertsViewOpenedAction()),
    [dispatch]
  );
  const routeListViewOpened = useCallback(
    () => dispatch(routeListViewOpenedAction()),
    [dispatch]
  );
  const routeDetailViewOpened = useCallback(
    () => dispatch(routeDetailViewOpenedAction()),
    [dispatch]
  );
  const modeSelectorViewOpened = useCallback(
    () => dispatch(modeSelectorViewOpenedAction()),
    [dispatch]
  );
  const vehicleDetailViewOpened = useCallback(
    () => dispatch(vehicleDetailViewOpenedAction()),
    [dispatch]
  );
  const payViewOpened = useCallback(
    () => dispatch(payViewOpenedAction()),
    [dispatch]
  );
  const viewClosed = useCallback(() => {
    dispatch(viewClosedAction());
  }, [dispatch]);

  return {
    tripPlanViewOpened,
    stopDetailViewOpened,
    locationDetailViewOpened,
    vehicleDetailViewOpened,
    tripRequestViewOpened,
    modeSelectorViewOpened,
    transitTrackerViewOpened,
    simpleStopViewOpened,
    serviceAlertsViewOpened,
    routeListViewOpened,
    routeDetailViewOpened,
    payViewOpened,
    viewClosed,
  };
};
